import { Combobox } from "../../../components/ui/combobox";
import { useState } from "react";
import { FormControl, FormField, FormItem, FormLabel } from "@/src/components/ui/form";
import { FiltersInput } from "../FiltersButton";
import { authFetch } from "@/src/lib/authFetch";

export type Customer = {
  id: number;
  firstName: string;
  lastName: string;
};

export const Customer = ({ defaultValue }: { defaultValue?: Customer | null }) => {
  const [customer, setCustomer] = useState<Customer | null>(defaultValue || null);

  return (
    <FormField<FiltersInput, "customer">
      name="customer"
      render={({ field }) => {
        return (
          <FormItem className="flex-grow w-1/2">
            <FormLabel className="text-xl text-semibold">Customer name</FormLabel>
            <FormControl>
              <Combobox
                className="flex w-full"
                loadOptions={(query) =>
                  authFetch<Customer[]>(`/user/all?keyword=${query}`, "GET").then((r) => {
                    return r;
                  })
                }
                placeholder="Search for customer..."
                value={customer}
                onChange={(v) => {
                  if (v && v.id !== customer?.id) {
                    setCustomer(v);
                    field.onChange(v);
                  } else {
                    setCustomer(null);
                    field.onChange(null);
                  }
                }}
                renderOption={(value) => (value ? value.firstName + " " + value.lastName : "Select a customer")}
              />
            </FormControl>
          </FormItem>
        );
      }}
    />
  );
};
